import { ApiError } from '../errors/api-error.js';

export class TenantComplianceService {
    constructor(api) { this.api = api; }

    async frameworks() { return this._wrap(() => this.api.frameworks(), 'Failed to load frameworks'); }
    async get() { return this._wrap(() => this.api.get(), 'Failed to load compliance config'); }
    async toggle(code, enabled, customizations) {
        return this._wrap(() => this.api.toggle(code, enabled, customizations), 'Failed to toggle', 'Uyumluluk güncellendi');
    }
    async listCatalogs() {
        return this._wrap(() => this.api.listCatalogs(), 'Failed to load catalogs');
    }
    async getCatalogScopeOptions() {
        return this._wrap(() => this.api.getCatalogScopeOptions(), 'Failed to load scope options');
    }
    async getCatalogCategoryOptions() {
        return this._wrap(() => this.api.getCatalogCategoryOptions(), 'Failed to load category options');
    }
    async listCatalogControls(tag, params = {}) {
        try {
            const r = await this.api.listCatalogControls(tag, params);
            return {
                success: true,
                data: r.data || [],
                pagination: r.pagination || {},
                meta: r.meta,
            };
        } catch (e) {
            if (e instanceof ApiError) throw e;
            if (e.statusCode || e.status) throw ApiError.fromResponse(e);
            throw new ApiError(e.message || 'Failed to load catalog controls', 500, 'UNKNOWN_ERROR', e);
        }
    }
    async updateCatalog(tag, payload = {}) {
        return this._wrap(
            () => this.api.updateCatalog(tag, payload),
            'Failed to update catalog',
            'Catalog updated'
        );
    }

    async _wrap(fn, fb, okMsg) {
        try { const r = await fn(); return { success: true, data: r.data, message: r.message || okMsg, meta: r.meta }; }
        catch (e) {
            if (e instanceof ApiError) throw e;
            if (e.statusCode || e.status) throw ApiError.fromResponse(e);
            throw new ApiError(e.message || fb, 500, 'UNKNOWN_ERROR', e);
        }
    }
}
